import i18n from 'i18next';
import i18nBackend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';

const getCurrentHost = process.env.REACT_APP_LANGUAGE_FILE_PATH ? process.env.REACT_APP_LANGUAGE_FILE_PATH.trim() + '/' : '';

const appNameReplacer = {
  type: 'postProcessor' as const,
  name: 'appNameReplacer',
  process(value: string, key: string | string[], options: any, translator: any) {
    const apiUrls = JSON.parse(localStorage.getItem('apiUrls') ?? '{}');
    const appName = apiUrls.APP_NAME;
    if (appName && typeof value === 'string') {
      return value.replace(/nextflow/gi, appName);
    }
    return value;
  }
};

i18n
  .use(appNameReplacer)
  .use(i18nBackend)
  .use(initReactI18next)
  .init({
    postProcess: ['appNameReplacer'],
    //supported langs
    fallbackLng: ['en', 'tr', 'fr', 'de', 'ru'],
    //default lang
    lng: localStorage.getItem('lang') || 'en',
    interpolation: {
      escapeValue: false,
    },
    backend: {
      loadPath: `.${process.env.PUBLIC_URL}/i18n/${getCurrentHost}{{lng}}.json`,
    },
    react: {
      useSuspense: false,
    },
  });

export default i18n;
